<div class="new-claim-modal">
    <form [formGroup]="claimForm" (submit)="$event.preventDefault()" class="new-claim-form">
        <div class="dialog-header d-flex justify-content-between align-items-center">
            <h1 mat-dialog-title class="mb-0">Start Claim</h1>
            <button type="button" mat-icon-button mat-dialog-close aria-label="Close start claim dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div mat-dialog-content class="new-claim-dialog-content">
            <div class="new-claim-search-bar">
                <mat-form-field class="example-full-width new-claim-search-bar__field" appearance="outline">
                    <mat-label>Serial Number</mat-label>
                    <input matInput placeholder="Enter serial number" formControlName="serial_number" (keydown.enter)="search($event)">
                    <button type="button" *ngIf="claimForm.controls.serial_number.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="clearInput()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>

                <button type="button" mat-flat-button color="primary" class="new-claim-search-bar__btn"
                    [disabled]="!claimForm.valid || submitting || searching" (click)="search($event)"
                    [class.spinner]="searching">
                    Search
                </button>
            </div>

            <p *ngIf="errorMessage" class="text-danger small mb-3">
                {{errorMessage}}
            </p>

            <div *ngIf="searchedCoverages.length == 0 && searchedEquipment" class="new-claim-results-empty">
                <p class="text-danger small mb-0">
                    There are no current plans found for the serial number provided. Please check the number and try again, or
                    contact the program administrator for assistance.
                </p>
            </div>

            <ng-container *ngIf="searchedCoverages.length > 0">
                <div class="new-claim-results-meta mb-2">
                    <small class="text-muted">{{searchedCoverages.length}} option(s) found</small>
                </div>
                <div class="coverage-list-scroll">
                    <div class="claim-option-card" *ngFor="let policy of searchedCoverages">
                        <div class="claim-option-card__header">
                            <div class="claim-option-card__identity">
                                <p class="small m-0"><span class="fw-bolder">Serial Number:</span> {{policy.serial_number}}</p>
                                <p class="small m-0"><span class="fw-bolder">Plan Number:</span> {{policy.policy_number}}</p>
                            </div>
                            <button type="button" mat-flat-button color="primary" class="claim-option-card__open-btn" [disabled]="submitting"
                                [class.spinner]="spin && claimCoverageID == policy.id" (click)="openClaim(policy.id)">
                                Open Claim
                            </button>
                        </div>

                        <div class="claim-option-card__body">
                            <p class="small m-0"><span class="fw-bolder">Equipment:</span>
                                {{policy.equipiment.year}} {{policy.equipiment.manufacturer}} {{policy.equipiment.model}}
                                {{policy.equipiment.equipment_type}}</p>

                            <div class="claim-option-card__coverages">
                            <ng-container *ngFor="let coverage of policy.coverages">
                                <p class="small m-0"><span class="fw-bolder">Coverage:</span> {{coverage.coverage}}</p>
                                <p class="small m-0"><span class="fw-bolder">Coverage Period:</span> {{coverage.term}} / {{coverageHours(coverage.hours)}}</p>
                                <p class="small m-0"><span class="fw-bolder">Effective Dates:</span> {{coverage.effective_date | epgDate: 'longDate'}} - {{coverage.expiration_date | epgDate: 'longDate'}}</p>
                            </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </form>
</div>